module.exports = [{
      plugin: require('/home/node/app/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
